import { Skeleton } from '@machobear/design-system'
import { noop } from 'lodash'

import useSessionComplete from '@/hooks/use-session-complete'
import { useTermsDialogContext } from '@/components/terms-dialog/context'

import { ListingCardItem } from '../map-list/listing-card-item'
import MaplibrePopup from './maplibre-popup'

const ListingMapPopup = ({ data, latitude, longitude, onClose }) => {
  const isLoggedIn = useSessionComplete()

  const { isLoading: isLoadingAgreements, checkAgreementMismatch } =
    useTermsDialogContext()
  const isAgreementMismatched = checkAgreementMismatch('trreb_agreements')

  if (isLoadingAgreements && isLoggedIn)
    return <Skeleton.Shape width={240} height={210} />

  return (
    <MaplibrePopup latitude={latitude} longitude={longitude}>
      <ListingCardItem
        id={'listing-map-popup'}
        key={data.listing_id}
        listing={data}
        hasSession={isLoggedIn}
        isAgreementMismatched={isAgreementMismatched}
        isAgreementLoading={isLoadingAgreements}
        onListingHover={noop}
        onClose={onClose}
        messageClickId="message-map-click"
        trackImpression={{
          id: data.listing_id,
          enabled: true,
          page: 'maps',
          section: 'listing-map-popup',
          sponsored: false
        }}
      />
    </MaplibrePopup>
  )
}
export default ListingMapPopup
